module.exports = __webpack_public_path__ + "static/media/petType-fish.8e5fa7fb.jpg";